import { isClient, isTestingEnv } from '@/app/_utils/env';
import { AnalyticsEvents } from '@/lib/google/AnalyticsEvents';
import { analyticsCouriers } from '@/lib/google/analytics';

export type Feature = {
  uuid: string;
  name: string;
};

export const Features: Record<string, Feature> = {
  DROP_OFF: {
    uuid: '0a7ba338-180f-4a0b-b18c-5a78afbfe076',
    name: 'dropoff'
  }
};

export function initFeature(feature: Feature | undefined, payload): Promise<void> {
  if (!feature) {
    return Promise.resolve();
  }

  const eventPayload = {
    feature: feature.name,
    feature_uuid: feature.uuid,
    ...payload
  };

  if (isClient() && isTestingEnv()) {
    return Promise.resolve();
  }

  return analyticsCouriers.sendEvent(AnalyticsEvents.FEATURE_INIT, eventPayload);
}

export function finishFeature(feature: Feature, payload, errorCode?): Promise<void> {
  if (!feature) {
    return Promise.resolve();
  }

  const eventPayload = {
    feature: feature.name,
    feature_uuid: feature.uuid,
    ...payload
  };

  if (errorCode) {
    eventPayload['error'] = errorCode;
  }

  if (isClient() && isTestingEnv()) {
    return Promise.resolve();
  }

  return analyticsCouriers.sendEvent(AnalyticsEvents.FEATURE_FINISHED, eventPayload);
}
